// @mui
import { styled } from '@mui/material/styles';
import { Grid, RadioGroup, CardActionArea, Typography, Stack } from '@mui/material';
// hooks
import useSettings from '../../../hooks/useSettings';
//
import BoxMask from './BoxMask';

// ----------------------------------------------------------------------

const BoxStyle = styled(CardActionArea)(({ theme }) => ({
  height: 72,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.disabled,
  border: `solid 1px ${theme.palette.grey[500_12]}`,
  borderRadius: Number(theme.shape.borderRadius) * 1.25,
}));

// ----------------------------------------------------------------------

const FONT_OPTIONS = ['Public Sans', 'Inter', 'DM Sans', 'Nunito Sans'] as const;

export default function SettingFontFamily() {
  const { themeFontFamily, onChangeFontFamily } = useSettings();

  return (
    <RadioGroup name="themeFontFamily" value={themeFontFamily} onChange={onChangeFontFamily}>
      <Grid dir="ltr" container spacing={2.5}>
        {FONT_OPTIONS.map((font) => {
          const isSelected = themeFontFamily === font;

          return (
            <Grid key={font} item xs={6}>
              <BoxStyle
                sx={{
                  ...(isSelected && {
                    color: 'primary.main',
                    boxShadow: (theme) => theme.customShadows.z20,
                  }),
                }}
              >
                <Stack alignItems="center" spacing={0.5}>
                  <Typography variant="h6" sx={{ fontFamily: font }}>
                    Aa
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 'bold' }}>
                    {font}
                  </Typography>
                </Stack>
                <BoxMask value={font} />
              </BoxStyle>
            </Grid>
          );
        })}
      </Grid>
    </RadioGroup>
  );
}
